import { createReducer } from 'redux-act';
import { clearData, setFifaDuplicatesLoading, setFifaDuplicatesData } from 'redux/actions/Profile/fifaDuplicatesActions';

const initialState = {
  data: [],
  isLoading: false,
};

const fifaDuplicatesReducer = createReducer(
  {
    [clearData]: () => ({ ...initialState }),
    [setFifaDuplicatesData]: (state, data) => ({
      ...state,
      data,
    }),
    [setFifaDuplicatesLoading]: (state, isLoading) => ({
      ...state,
      isLoading,
    }),
  },
  initialState,
);

export default fifaDuplicatesReducer;
